<template>
  <div
    class="tt-wrapper meek-icon"
    :aria-label="tooltipText"
    v-tooltip:[tooltipPositionArg]="tooltipBinding"
    @keydown.enter.prevent="emitFunction"
    @click="onClick"
  >
    <slot />
  </div>
</template>

<script>
const TOOLTIP_POSITIONS = new Set(['top', 'bottom', 'left', 'right'])

export default {
  name: 'TooltipWrapper',
  props: {
    tooltipText: String,
    allowSpace: Boolean,
    preventClick: Boolean,
    position: String,
    tooltipPosition: String
  },
  computed: {
    resolvedPosition () {
      const pos = this.position || this.tooltipPosition || 'top'
      return TOOLTIP_POSITIONS.has(pos) ? pos : 'top'
    },
    tooltipPositionArg () {
      return { position: this.resolvedPosition }
    },
    tooltipBinding () {
      const text = this.tooltipText
      if (!text || !String(text).trim()) return null
      const classes = ['primevue-tooltip']
      if (this.$store.getters.getProductMode === 'Meek') {
        classes.push('primevue-tooltip--meek')
      }
      return {
        value: text,
        class: classes.join(' '),
        escape: true
      }
    }
  },
  methods: {
    onClick () {
      if (!this.preventClick) {
        this.emitFunction()
      }
    },
    emitFunction () {
      this.$emit('emitFunction')
    }
  }
}
</script>
